/**
 * Enum for Channel Routes values.
 * @readonly
 * @enum {string}
 */
export enum EChannelRouter {
  /** Chatbot channel. */
  CHATBOT = 'chatbot',

  /** Mi Claro App channel. */
  MCAPP = 'mcapp',

  /** Mi claro express channel. @default */
  MCE = 'mce',

  /** Mi claro web channel. */
  MCWEB = 'mcw'
}
